import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Codes from "@/pages/Codes";
import Sources from "@/pages/Sources";
import Members from "@/pages/Members";
import Activity from "@/pages/Activity";
import Install from "@/pages/Install";
import TestLogin from "@/pages/TestLogin";

function Protected({ admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !user.is_admin) return <Navigate to="/codes" replace />;
  return <Outlet />;
}

function App() {
  useEffect(() => { document.title = "Passcode Hub"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/test-login" element={<TestLogin />} />
          <Route element={<Protected />}>
            <Route element={<Layout />}>
              <Route path="/codes" element={<Codes />} />
              <Route path="/activity" element={<Activity />} />
              <Route path="/install" element={<Install />} />
              <Route element={<Protected admin />}>
                <Route path="/sources" element={<Sources />} />
                <Route path="/members" element={<Members />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/codes" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
